module.exports = __webpack_public_path__ + "assetsclientes/img/seguridad.993c145e.svg";